import { Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Dropdown from "./dropdown/Dropdown";
import {
  MenuItemsParametrages, MenuItemsBudget, MenuItemsExtraction,
  MenuItemsFacturation, MenuItemsProduction, MenuItemsCommission,
  MenuItemsReforecast
} from "../../constants/MenuItems";
import { Avatar, Badge, IconButton, styled } from "@mui/material";
import DropdownFacture from "./dropdown/DropdownFacture";
import DropdownInfoUser from "./dropdown/DropdownInfoUser";
import UserInformation from "../../types/UserInformation";
import { useSelector } from "react-redux";
import { Reducers } from "../../redux/reducers";
import { MAX_MOBILE_WIDTH, XS_BREAKPOINT, profilToAccessToAllFonctionnality, publicPaths } from "../../constants/Constants";
import MenuItem from "../../types/MenuItem";
import "./Navbar.css";
import Cookies from "universal-cookie";
import { AlertType } from "../../types/AlertType";

enum Menus {
  PARAMETRAGE,
  TARIF_AND_COUT,
  MANAGERS,
  PREVISIONNEL,
  BUDGET,
  EXTRACTION,
  FACTURATION,
  COMMISSION
}

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const Navbar = () => {
  const logger = useSelector<Reducers>(
    (state) => state.logger
  ) as UserInformation;

  const location = useLocation();

  const cookies = new Cookies();
  const verticalMenu: boolean = cookies.get("menu");

  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [alertMessage, setAlerteMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<AlertType>("success");

  const [click, setClick] = useState(false);
  const [dropdownParametrage, setDropdownParametrage] = useState<boolean>(false);
  const [dropdownProduction, setDropdownProduction] = useState<boolean>(false);
  const [dropdownBudget, setDropdownBudget] = useState<boolean>(false);
  const [dropdownReforecast, setDropdownReforecast] = useState<boolean>(false);
  const [dropdownExtraction, setDropdownExtraction] = useState<boolean>(false);
  const [dropdownFacture, setDropdownFacture] = useState<boolean>(false);
  const [dropdownCommission, setDropdownCommission] = useState<boolean>(false);
  const [dropdownInfoUser, setDropdownInfoUser] = useState<boolean>(false);

  const [openCollapseParametrage, setOpenCollapseParametrage] = useState<boolean>(false);
  const [openCollapseFacture, setOpenCollapseFacture] = useState<boolean>(false);

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  let initialConnectedUser: string = '';

  if (logger && (logger?.prenom && logger?.name)) {
    initialConnectedUser = `${logger?.prenom[0]}${logger?.name[0]}`;
  }

  useEffect(() => {
    if (window.innerWidth > MAX_MOBILE_WIDTH) {
      setOpenCollapseParametrage(false);
    }
  }, [window.innerWidth]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const logoWidthValue = () => {
    if (screenWidth < XS_BREAKPOINT) {
      return '70%';
    }

    if ((screenWidth > XS_BREAKPOINT) && (screenWidth < 900)) {
      return '60%';
    }

    if (!verticalMenu) {
      return '65%';
    }

    return '48%';
  };

  const closeMobileMenu = () => setClick(false);

  const onMouseEnterParametrage = () => {
    if (window.innerWidth < 960) {
      setDropdownParametrage(false);
    } else {
      setDropdownParametrage(true);
    }
  };

  const onMouseLeaveParametrage = () => {
    if (window.innerWidth < 960) {
      setDropdownParametrage(false);
    } else {
      setDropdownParametrage(false);
    }
  };

  const onMouseEnterProduction = () => {
    if (window.innerWidth < 960) {
      setDropdownProduction(false);
    } else {
      setDropdownProduction(true);
    }
  };

  const onMouseLeaveProduction = () => {
    if (window.innerWidth < 960) {
      setDropdownProduction(false);
    } else {
      setDropdownProduction(false);
    }
  };

  const onMouseEnterBudget = () => {
    if (window.innerWidth < 960) {
      setDropdownBudget(false);
    } else {
      setDropdownBudget(true);
    }
  };

  const onMouseLeaveBudget = () => {
    if (window.innerWidth < 960) {
      setDropdownBudget(false);
    } else {
      setDropdownBudget(false);
    }
  };

  const onMouseEnterReforecast = () => {
    if (window.innerWidth < 960) {
      setDropdownReforecast(false);
    } else {
      setDropdownReforecast(true);
    }
  };

  const onMouseLeaveReforecast = () => {
    if (window.innerWidth < 960) {
      setDropdownReforecast(false);
    } else {
      setDropdownReforecast(false);
    }
  };

  const onMouseEnterExtraction = () => {
    if (window.innerWidth < 960) {
      setDropdownExtraction(false);
    } else {
      setDropdownExtraction(true);
    }
  };

  const onMouseLeaveExtraction = () => {
    if (window.innerWidth < 960) {
      setDropdownExtraction(false);
    } else {
      setDropdownExtraction(false);
    }
  };

  const onMouseEnterCommission = () => {
    if (window.innerWidth < 960) {
      setDropdownFacture(false);
    } else {
      setDropdownFacture(true);
    }
  };

  const onMouseLeaveCommission = () => {
    if (window.innerWidth < 960) {
      setDropdownCommission(false);
    } else {
      setDropdownCommission(false);
    }
  };

  const onMouseEnterFacture = () => {
    if (window.innerWidth < 960) {
      setDropdownFacture(false);
    } else {
      setDropdownFacture(true);
    }
  };

  const onMouseLeaveFacture = () => {
    if (window.innerWidth < 960) {
      setDropdownFacture(false);
    } else {
      setDropdownFacture(false);
    }
  };

  const onMouseEnterInFoUser = () => {
    setDropdownInfoUser(true);
  };

  const onMouseLeaveInFoUser = () => {
    setDropdownInfoUser(false);
  };

  const onClickInfoUser = () => {
    setDropdownInfoUser(!dropdownInfoUser);
  };

  const resetCollapse = () => {
    setOpenCollapseParametrage(false);
    setOpenCollapseFacture(false);
  };

  const handleOpenCollapse = (key: number) => {
    if (window.innerWidth < MAX_MOBILE_WIDTH) {
      resetCollapse();
      switch (key) {
        case Menus.PARAMETRAGE:
          setOpenCollapseParametrage(!openCollapseParametrage);
          break;
        case Menus.FACTURATION:
          setOpenCollapseFacture(!openCollapseFacture);
          break;
      }
    }
  };

  const displayMenu = (menuItem: MenuItem[]) => {
    if (logger?.profils?.libelle && profilToAccessToAllFonctionnality?.includes(logger?.profils?.libelle)) {
      return true;
    } else {
      return menuItem.find(elem => logger?.features?.includes(elem?.code));
    }
  };


  const showMenu = !publicPaths?.includes(location.pathname) && true;

  return (
    <nav className="navbar">
      <Link to="/acceuil" className="navbar-logo" onClick={closeMobileMenu}>
        <img
          src="images/logo_outsourcia.png"
          // className="logo"
          width={logoWidthValue()}
          alt="Logo Outsourcia"
        />
      </Link>
      <Fragment>
        {
          !verticalMenu && (
            <>
              <ul className={click ? "nav-menu active" : "nav-menu"}>
                {showMenu && (
                  displayMenu(MenuItemsParametrages) && (
                    <li
                      className="nav-item"
                      onMouseEnter={onMouseEnterParametrage}
                      onMouseLeave={onMouseLeaveParametrage}
                    >
                      <Link
                        to="#"
                        className="nav-links"
                        onClick={() => handleOpenCollapse(Menus.PARAMETRAGE)}
                      >
                        Paramètrages
                      </Link>
                      {dropdownParametrage && (
                        <Dropdown menuItems={MenuItemsParametrages} user={logger} />
                      )}
                    </li>
                  ))}

                {showMenu && (
                  displayMenu(MenuItemsProduction) && (
                    <li
                      className="nav-item"
                      onMouseEnter={onMouseEnterProduction}
                      onMouseLeave={onMouseLeaveProduction}
                    >
                      <Link to="#" className="nav-links" onClick={closeMobileMenu}>
                        Production
                      </Link>
                      {dropdownProduction && (
                        <Dropdown menuItems={MenuItemsProduction} user={logger} />
                      )}
                    </li>
                  ))}

                {/* {showMenu && (
            displayMenu(MenuItemsPrevisionnel) && (
              <li
                className="nav-item"
                onMouseEnter={onMouseEnterPrevisionnel}
                onMouseLeave={onMouseLeavePrevisionnel}
              >
                <Link to="#" className="nav-links" onClick={closeMobileMenu}>
                  Prévisionnel
                </Link>
                {dropdownPrevisionnel && (
                  <Dropdown menuItems={MenuItemsPrevisionnel} user={logger} />
                )}
              </li>
                ))} */}

                {showMenu && (
                  displayMenu(MenuItemsBudget) && (
                    <li
                      className="nav-item"
                      onMouseEnter={onMouseEnterBudget}
                      onMouseLeave={onMouseLeaveBudget}
                    >
                      <Link to="#" className="nav-links" onClick={closeMobileMenu}>
                        Budget
                      </Link>
                      {dropdownBudget && (
                        <Dropdown menuItems={MenuItemsBudget} user={logger} />
                      )}
                    </li>
                  ))}

                {showMenu && (
                  displayMenu(MenuItemsReforecast) && (
                    <li
                      className="nav-item"
                      onMouseEnter={onMouseEnterReforecast}
                      onMouseLeave={onMouseLeaveReforecast}
                    >
                      <Link to="#" className="nav-links" onClick={closeMobileMenu}>
                        Reforecast
                      </Link>
                      {dropdownReforecast && (
                        <Dropdown menuItems={MenuItemsReforecast} user={logger} />
                      )}
                    </li>
                  ))}

                {showMenu && (
                  displayMenu(MenuItemsExtraction) && (
                    <li
                      className="nav-item"
                      onMouseEnter={onMouseEnterExtraction}
                      onMouseLeave={onMouseLeaveExtraction}
                    >
                      <Link to="#" className="nav-links" onClick={closeMobileMenu}>
                        Extraction
                      </Link>
                      {dropdownExtraction && (
                        <Dropdown menuItems={MenuItemsExtraction} user={logger} />
                      )}
                    </li>
                  ))}

                {showMenu && (
                  displayMenu(MenuItemsFacturation) && (
                    <li
                      className="nav-item"
                      onMouseEnter={onMouseEnterFacture}
                      onMouseLeave={onMouseLeaveFacture}
                    >
                      <Link
                        to="#"
                        className="nav-links"
                        onClick={() => handleOpenCollapse(Menus.FACTURATION)}
                      >
                        Facturation
                      </Link>
                      {dropdownFacture && <DropdownFacture user={logger} />}
                      {openCollapseFacture && (
                        <Dropdown menuItems={MenuItemsFacturation} user={logger} />
                      )}
                    </li>
                  ))}

                {showMenu && (
                  displayMenu(MenuItemsCommission) && (
                    <li
                      className="nav-item"
                      onMouseEnter={onMouseEnterCommission}
                      onMouseLeave={onMouseLeaveCommission}
                    >
                      <Link to="#" className="nav-links" onClick={closeMobileMenu}>
                        Commission
                      </Link>
                      {dropdownCommission && (
                        <Dropdown menuItems={MenuItemsCommission} user={logger} />
                      )}
                    </li>
                  ))}
              </ul>
            </>
          )}
      </Fragment>
      {
        showMenu &&
        (<div
          className="menu-user"
          onClick={() => onClickInfoUser()}
          onMouseEnter={onMouseEnterInFoUser}
          onMouseLeave={onMouseLeaveInFoUser}
        >
          <IconButton
            id="basic-menu"
            size="large"
            aria-label="account of current user"
            aria-controls="basic-menu"
            aria-haspopup="true"
            color="inherit"
          >
            <StyledBadge
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              variant="dot"
            >
              <Avatar
                sx={{
                  bgcolor: "#FC8404",
                  width: (screenWidth < MAX_MOBILE_WIDTH) ? 30 : null,
                  height: (screenWidth < MAX_MOBILE_WIDTH) ? 30 : null,
                  fontSize: (screenWidth < MAX_MOBILE_WIDTH) ? 16 : null,
                }}
              >
                {initialConnectedUser}
              </Avatar>
            </StyledBadge>
          </IconButton>
          {dropdownInfoUser && <DropdownInfoUser
            screenWidth={screenWidth}
            setAlertType={setAlertType}
            setOpenSnack={setOpenSnack}
            setAlerteMessage={setAlerteMessage}
          />}
        </div>)}
    </nav>
  );
};

export default Navbar;
